import { render, staticRenderFns } from "./about-bcn.vue?vue&type=template&id=89283416"
import script from "./about-bcn.vue?vue&type=script&lang=js"
export * from "./about-bcn.vue?vue&type=script&lang=js"
import style0 from "./about-bcn.vue?vue&type=style&index=0&id=89283416&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports